import { render, staticRenderFns } from "./QryConfiguration.vue?vue&type=template&id=1dea806a&"
import script from "./QryConfiguration.vue?vue&type=script&lang=js&"
export * from "./QryConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports